module.exports = __webpack_public_path__ + "static/media/oneinch.0444c4cc.svg";